import React, { useEffect, useRef } from "react";
import "./style.css";

const sections = [
  {
    title: "born & raised",
    cards: [
      {title: "Kosovo made me", desc: "I come from Kosovo, which means I have a sturdy sense of humor, stubborn problem-solving skills, an uncanny ability to find the best coffee in any city, and a surprising ability to survive chaos with a smile." },
    ],
  },
  {
    title: "cozy chaos",
    cards: [
      { title: "netflix’s worst enemy", desc: "In my free time, I fully commit to destroying streaming platforms one series at a time. I also enjoy buying decorative things I probably don’t need, making presents for people I like, and living in a world of rain, rainbows, and bright colors (indoors, obviously)." },
    ],
  },
  {
    title: "low outdoors",
    cards: [
      { title: "professional indoors person", desc: "I thrive in cozy, colorful spaces surrounded by my 5 cats, snacks, and creative chaos. Basically, if it’s comfortable, aesthetic, and rainy, I’m happy." },
    ],
  },
  {
    title: "nice human being",
    cards: [
      { title: "they say I bring light", desc: "I’m positive, kind, and apparently bring light to every room I enter, though I suspect people say that mostly to make me feel better about my questionable jokes." },
    ],
  },
];

export default function Journey() {
  const containerRef = useRef(null);
  const iconRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      const path = pathRef.current;
      const icon = iconRef.current;

      if (!container || !path || !icon) return;

      const containerRect = container.getBoundingClientRect();
      const containerTop = containerRect.top;
      const containerHeight = containerRect.height;
      const windowHeight = window.innerHeight;

      let scrollProgress = (windowHeight - containerTop) / (containerHeight + windowHeight);
      scrollProgress = Math.min(Math.max(scrollProgress, 0), 1);

      const pathLength = path.getTotalLength();
      const point = path.getPointAtLength(scrollProgress * pathLength);

      const delta = 1;
      const nextPoint = path.getPointAtLength(Math.min(scrollProgress * pathLength + delta, pathLength));
      const angle = Math.atan2(nextPoint.y - point.y, nextPoint.x - point.x) * (180 / Math.PI);

      icon.style.transform = `translate(${point.x}px, ${point.y}px) translate(-50%, -50%) rotate(${angle}deg)`;
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="journey-wrapper" ref={containerRef}>
      <svg className="journey-svg" viewBox="0 0 400 2000" preserveAspectRatio="none">
        <path
          ref={pathRef}
          d="M200 0 
             C 350 300, 50 500, 200 800 
             C 350 1100, 50 1300, 200 1600
             C 300 1850, 150 1950, 200 2000"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeDasharray="10 10"
        />
      </svg>

      <div className="moving-icon" ref={iconRef}>
        <svg width="100" height="100" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <polygon 
            points="100,10 124.5,70.1 190.5,70.1 136.8,110.9 155.5,180 100,140 44.5,180 63.2,110.9 9.5,70.1 75.5,70.1"
            fill="#166544" 
            stroke="#FFB1D2" 
            stroke-width="2"/>

        <line x1="100" y1="10" x2="155.5" y2="180" stroke="#FFB1D2" stroke-width="2"/>
        <line x1="155.5" y1="180" x2="9.5" y2="70.1" stroke="#FFB1D2" stroke-width="2"/>
        <line x1="9.5" y1="70.1" x2="190.5" y2="70.1" stroke="#FFB1D2" stroke-width="2"/>
        <line x1="190.5" y1="70.1" x2="44.5" y2="180" stroke="#FFB1D2" stroke-width="2"/>
        <line x1="44.5" y1="180" x2="100" y2="10" stroke="#FFB1D2" stroke-width="2"/>
        </svg>
      </div>

      {sections.map((section, i) => (
        <div
          className={`journey-section ${
              i === 1 ? "section-design" : i === 3 ? "section-build" : ""
            }`}
            key={i}
          >
          <h2 className="section-title">{section.title}</h2>

          <div className="cards">
            {section.cards.map((card, index) => (
              <div className="card" key={index}>
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}